const projects = [
  {
    id: 2,
    image:
      "https://screenshot-proxy.netlify.app/f_avif,w_336/https://d33wubrfki0l68.cloudfront.net/626df855f34b1976efc1a27e/screenshot_2022-05-01-03-03-52-0000.png",
    title: "Paginated Searchable Table",
    githubLink:
      "https://github.com/Ericssm96/react-projects/tree/main/paginated-table",
    demo: "https://paginated-list.netlify.app",
  },
  {
    id: 3,
    image:
      "https://screenshot-proxy.netlify.app/f_avif,w_336/https://d33wubrfki0l68.cloudfront.net/626e0728d7f2897c5a41cfae/screenshot_2022-05-01-04-06-27-0000.png",
    title: "Color Generator",
    githubLink:
      "https://github.com/Ericssm96/react-projects/tree/main/color-generator",
    demo: "https://estefanos-color-generator.netlify.app",
  },
  {
    id: 4,
    image:
      "https://screenshot-proxy.netlify.app/f_avif,w_336/https://d33wubrfki0l68.cloudfront.net/626e091c299e457b6d692685/screenshot_2022-05-01-04-15-01-0000.png",
    title: "Grocery Buddy",
    githubLink:
      "https://github.com/Ericssm96/react-projects/tree/main/grocery-list",
    demo: "https://estefanos-grocery-bud.netlify.app",
  },
  {
    id: 5,
    image:
      "https://screenshot-proxy.netlify.app/f_webp,w_336/https://d33wubrfki0l68.cloudfront.net/624ceb0ae7a4d42d1f832dd5/screenshot_2022-04-06-01-21-27-0000.png",
    title: "Slider Reviews",
    githubLink:
      "https://github.com/Ericssm96/react-projects/tree/main/slider-reviews",
    demo: "https://e-stefanos-slider-reviews.netlify.app/",
  },
  {
    id: 6,
    image:
      "https://screenshot-proxy.netlify.app/f_avif,w_336/https://d33wubrfki0l68.cloudfront.net/6243ba1a1fb79863438fbb9e/screenshot_2022-03-30-02-02-16-0000.png",
    title: "Formulário / Sign Up Form",
    githubLink:
      "https://github.com/Ericssm96/react-projects/tree/main/formulario-cadastro",
    demo: "https://formulario-controlado-simples-react.netlify.app/",
  },
  {
    id: 7,
    image:
      "https://screenshot-proxy.netlify.app/f_avif,w_336/https://d33wubrfki0l68.cloudfront.net/624baf9bffe33920105a83c3/screenshot_2022-04-05-02-55-30-0000.png",
    title: "Alternating Views Resume",
    githubLink:
      "https://github.com/Ericssm96/react-projects/tree/main/alternating-views-resume",
    demo: "https://e-stefanos-job-experience-tabs.netlify.app/",
  },
  {
    id: 8,
    image:
      "https://screenshot-proxy.netlify.app/f_avif,w_336/https://d33wubrfki0l68.cloudfront.net/624b5f574b28252a64a46c84/screenshot_2022-04-04-21-13-01-0000.png",
    title: "Menu With Filter",
    githubLink:
      "https://github.com/Ericssm96/react-projects/tree/main/menu-with-filter",
    demo: "https://e-stefanos-menu-with-filter.netlify.app/",
  },
  {
    id: 9,
    image:
      "https://screenshot-proxy.netlify.app/f_avif,w_336/https://d33wubrfki0l68.cloudfront.net/624b3ea470ae3a07aab70ba8/screenshot_2022-04-04-18-53-31-0000.png",
    title: "FAQ Page",
    githubLink:
      "https://github.com/Ericssm96/react-projects/tree/main/faq-accordion",
    demo: "https://e-stefanos-faq-page.netlify.app/",
  },
  {
    id: 10,
    image:
      "https://screenshot-proxy.netlify.app/f_avif,w_336/https://d33wubrfki0l68.cloudfront.net/624a60923a7b7f2200b79f14/screenshot_2022-04-04-03-06-00-0000.png",
    title: "Tours",
    githubLink: "https://github.com/Ericssm96/react-projects/tree/main/tours",
    demo: "https://e-stefanos-tours.netlify.app/",
  },
  {
    id: 11,
    image:
      "https://screenshot-proxy.netlify.app/f_avif,w_336/https://d33wubrfki0l68.cloudfront.net/624b35d346bfb10711d1ef6c/screenshot_2022-04-04-18-15-55-0000.png",
    title: "Simpler Reviews",
    githubLink: "https://github.com/Ericssm96/react-projects/tree/main/reviews",
    demo: "https://e-stefanos-reviews-list.netlify.app/",
  },
  {
    id: 12,
    image:
      "https://screenshot-proxy.netlify.app/f_avif,w_336/https://d33wubrfki0l68.cloudfront.net/6249de5f35b22512ea9adc1f/screenshot_2022-04-03-17-50-29-0000.png",
    title: "Birthday Reminder",
    githubLink:
      "https://github.com/Ericssm96/react-projects/tree/main/birthday-reminder",
    demo: "https://e-stefanos-job-experience-tabs.netlify.app/",
  },
  {
    id: 13,
    image:
      "https://screenshot-proxy.netlify.app/f_avif,w_336/https://d33wubrfki0l68.cloudfront.net/6243b95339937959b8351517/screenshot_2022-03-30-01-58-53-0000.png",
    title: "Bloco de Notas / Notepad",
    githubLink:
      "https://github.com/Ericssm96/react-projects/tree/main/bloco-de-notas",
    demo: "https://bloco-de-notas-simples-react.netlify.app/",
  },
];

export default projects;
